import { Component, OnInit } from '@angular/core';
import { AppService } from '@cigna/cigna-for-brokers/shared/data-access';
import {
  CfbFeatureFlagService,
  CfbIntegrationRegistrationService,
  isPublicRegistrationRoute,
} from '@cigna/cigna-for-brokers/shared/util';
import { TranslateService } from '@ngx-translate/core';
import { Router, Event, NavigationEnd } from '@angular/router';

@Component({
  selector: 'cigna-layout-unsecure',
  templateUrl: './layout-unsecure.component.html',
  styleUrls: ['./layout-unsecure.component.scss'],
})
export class LayoutUnSecureComponent implements OnInit {
  isSiteDown: boolean;
  layoutDisableRoutes: string[] = ['/public/campaign'];
  isLayoutEnabled = true;
  isIntegrationOn = false;

  constructor(
    private translate: TranslateService,
    private router: Router,
    private _appService: AppService,
    private _cfbFeatureFlagService: CfbFeatureFlagService,
    private _cfbIntegrationRegistrationService: CfbIntegrationRegistrationService,
  ) {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.isLayoutEnabled =
          this.layoutDisableRoutes.filter((x) => event.url.indexOf(x) >= 0)
            .length === 0;

        this.syncIntegrationState(event.urlAfterRedirects);
      }
    });
  }

  ngOnInit(): void {
    const siteDown = this.translate.instant(`global.isSiteDown`);
    this.isSiteDown = siteDown === 'true';
    this.isIntegrationOn = this._cfbFeatureFlagService.isIntegrationOn();
    this.syncIntegrationState(this.router.url);
  }

  private syncIntegrationState(urlAfterRedirects: string): void {
    if (urlAfterRedirects.includes('/public/login')) {
      return;
    }

    if (
      isPublicRegistrationRoute(urlAfterRedirects) &&
      this._cfbFeatureFlagService.isIntegrationOn()
    ) {
      this._cfbIntegrationRegistrationService.activate();
      return;
    }

    if (
      isPublicRegistrationRoute(urlAfterRedirects) &&
      this._cfbIntegrationRegistrationService.isActive()
    ) {
      this._cfbIntegrationRegistrationService.syncShellState();
      return;
    }

    this._appService.setIntegrationOn(false);
  }
}
